import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { withRouter } from "react-router-dom";
import { Breadcrumb, Loader, Header } from "semantic-ui-react";
import {
  GET_STUDENT_FIELDS,
  UPDATE_STUDENT_REPORT,
  SEND_STUDENT_REPORT,
} from "../GraphQL";
import ReportForm from "../components/ReportForm";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { capitalize } from "utils";

const NewReportPage = ({ match, history }) => {
  const newReportId = useRef(uuidv4());
  console.log("newReportId", newReportId);
  const { loading, error, data } = useQuery(GET_STUDENT_FIELDS, {
    variables: { studentId: match.params.studentId },
  });

  const [updateStudentReport] = useMutation(UPDATE_STUDENT_REPORT, {
    update(cache, { data: { editReport } }) {
      console.log("update", editReport);
      cache.modify({
        id: `Student:${match.params.studentId}`,
        fields: {
          pagedReports(existingPagedReports = []) {
            return {
              ...existingPagedReports,
              reports: [editReport, ...existingPagedReports.reports],
            };
          },
        },
      });
    },
  });

  const [sendReport] = useMutation(SEND_STUDENT_REPORT, {
    update(cache, { data: { addTodo } }) {
      cache.modify({
        id: cache.identify(newReportId.current),
        fields: {
          sent() {
            return true;
          },
        },
      });
    },
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    throw error;
  }

  const student = data.getStudent;

  const newReport = {
    id: newReportId.current,
    sent: false,
    student: student.id,
    fields: student.fields,
    reportType: student.reportFrequency,
    date: moment().startOf("day").format(),
  };
  const reportTitle = `${capitalize(newReport.reportType)} Report for ${
    student.name
  }`;

  return (
    <div>
      <div
        style={{
          backgroundColor: "#fff",
          position: "sticky",
          top: 55,
          zIndex: 1,
        }}
      >
        <Breadcrumb size="tiny">
          <Breadcrumb.Section>
            <Link to="/">Home</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>
            <Link to="/students">My Students</Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section>
            <Link to={`/students/${data.getStudent.id}`}>
              {data.getStudent.name}
            </Link>
          </Breadcrumb.Section>
          <Breadcrumb.Divider icon="right angle" />
          <Breadcrumb.Section active>New Report</Breadcrumb.Section>
        </Breadcrumb>
        <Header
          style={{ backgroundColor: "#fff", marginBottom: "1em" }}
          as="h3"
          subheader={moment(newReport.date).format("LL")}
          content={reportTitle}
          dividing
        />
      </div>
      <ReportForm
        canAddAttachments={student.myTeacher.isProUser}
        report={newReport}
        student={student}
        isNew
        onCancel={() => history.push(`/students/${data.getStudent.id}`)}
        onSend={async () => {
          await sendReport({
            variables: {
              student: match.params.studentId,
              report: newReport.id,
            },
            onCompleted: () => {
              history.push(`/students/${student.id}`);
            },
            update: (cache, { data: { sendReport } }) => {
              console.log("update", sendReport);
              cache.modify({
                id: cache.identify(newReport),
                fields: {
                  sent(existingSent = false) {
                    return true;
                  },
                },
              });
            },
          });
        }}
        onSave={async (report) => {
          const updatedReport = Object.assign({}, newReport, report);
          await updateStudentReport({
            variables: { input: updatedReport },
          });
        }}
      />
    </div>
  );
};

export default withRouter(NewReportPage);
